






import DefaultLayout from './DefaultLayout.vue'
import NoneLayout from '@/components/NoneLayout.vue'
import Vue from 'vue'
import Utils from '@/utils/utils'

export default Vue.extend({
  components: {
    DefaultLayout,
    NoneLayout,
  },
  methods: {
    layout(): string {
      const layout: string = this.$route.meta.layout ? this.$route.meta.layout + '-layout' : 'default-layout'
      return layout
    },
  },
  watch: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    $route(to, from) {
      Utils.setPageTitle(to)
    },
  },
  data: () => ({
    //
  }),
})
